// extracted by mini-css-extract-plugin
export default {"edit":"src-components-ImageFocusPointEdit-css-module__edit--JnXyi"};